import { api } from './client';

export interface LoginResponse {
  access: string;
}

// `access` is null on anonymous bootstrap (no refresh cookie). The backend
// returns 200 + { access: null } in that case so the SPA can route the user
// to /login without lighting up DevTools with a fake 401.
export interface RefreshResponse {
  access: string | null;
}

export const authApi = {
  login: (email: string, password: string, captchaVerifyParam?: string) =>
    api
      .post<LoginResponse>('/auth/login', {
        email,
        password,
        captcha_verify_param: captchaVerifyParam,
      })
      .then((r) => r.data),

  refresh: () => api.post<RefreshResponse>('/auth/refresh').then((r) => r.data),

  logout: () => api.post('/auth/logout').then(() => undefined),
};
